import { EAR_TYPES } from "constants/products";
import type { SaleItem } from "services/types/sale-items.type";

/** Fields required to resolve serial # and ear consistently across billing, invoices, and merge tags. */
export type LineItemSerialEarFields = Pick<
  SaleItem,
  "patient_products" | "inventory_product" | "order_item"
>;

export function getLineItemSerialRaw(item: LineItemSerialEarFields): string {
  const fromPatientProducts = item.patient_products
    ?.map(({ inventory_product }) => inventory_product?.serial_number)
    ?.filter(Boolean)
    ?.join(", ");
  return (
    fromPatientProducts ||
    item.inventory_product?.serial_number ||
    item.order_item?.patient_product?.serial_number ||
    ""
  );
}

export function getLineItemEarDisplay(item: LineItemSerialEarFields): string {
  const fromPatientProducts = item.patient_products
    ?.map(({ ear, inventory_product }) =>
      EAR_TYPES.getFromCode(ear || inventory_product?.ear)
    )
    ?.filter(Boolean)
    ?.join(", ");
  return (
    fromPatientProducts ||
    EAR_TYPES.getFromCode(item.inventory_product?.ear) ||
    EAR_TYPES.getFromCode(item.order_item?.patient_product?.ear) ||
    ""
  );
}
